import { Stack } from '@mui/material'
import { getCertificateRuleById } from 'api/certificates'
import { getCourses } from 'api/courses'
import { getLessons } from 'api/lessons'
import FailPlaceholder from 'components/placeholders/FailPlaceholder'
import LoadingPlaceholder from 'components/placeholders/LoadingPlaceholder'
import { useEntityDataControl } from 'hooks/useEntityDataControl'
import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { selectOptionsFromTableResponse } from 'utils'
import { CertificatesEditPageForm } from '../CertificatesEditPageForm/CertificatesEditPageForm'
import { CertificatesHistory } from '../CertificatesHistory/CertificatesHistory'

export function CertificatesEditPage() {
  const { id } = useParams()

  const { data, loading, setLoading, setData } = useEntityDataControl({
    id,
    loadFunc: getCertificateRuleById,
    warning: "Can't load certificate",
  })

  const coursesOptions = useQuery('getCourses', () => getCourses(), {
    select: selectOptionsFromTableResponse,
  })

  const lessonsOptions = useQuery('getLessons', () => getLessons({}), {
    select: selectOptionsFromTableResponse,
  })

  if (coursesOptions.isLoading || lessonsOptions.isLoading) {
    return <LoadingPlaceholder />
  }

  if (!coursesOptions.data) {
    return <FailPlaceholder error="Can't load data of Courses" />
  }

  if (!lessonsOptions.data) {
    return <FailPlaceholder error="Can't load data of Lessons" />
  }

  if (id !== undefined && loading) {
    return <LoadingPlaceholder />
  }

  if (id !== undefined && !data) {
    return <FailPlaceholder error="Can't load data of Query" />
  }

  return (
    <Stack gap={3}>
      <CertificatesEditPageForm
        data={data}
        setData={setData}
        setLoading={setLoading}
        coursesOptions={coursesOptions.data}
        lessonsOptions={lessonsOptions.data}
      />

      {id !== undefined && data && (
        <CertificatesHistory
          id={data.id}
          coursesOptions={coursesOptions.data}
          lessonsOptions={lessonsOptions.data}
        />
      )}
    </Stack>
  )
}
